import { Button } from '@mui/material';
import CustomButton from './CustomButton';

const downloadTemplate = () => {
  const csvContent = 
    'NOM,PRENOMS,EMAIL,TELEPHONE,ABONNE\n' +
    'Doe,John,john.doe@email.com,0123456789,oui\n';

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'contacts_template.csv');
  link.click();
};

export default function ImportContactTemplateButton() {
  return (
    <CustomButton type={'tertiaire'} buttonText={'Télécharger le template CSV'} onClick={downloadTemplate} />
  );
}
